import { BehaviorSubject } from 'rxjs';
import { IMenu } from './models/core/menu';

export const menu$ = new BehaviorSubject<IMenu[]>([

  {
    route: "lab-user-menu",
    name: "Login",
    type: "link",
    icon: "domain"
  }
]);

export const loginMenu$ = new BehaviorSubject<IMenu[]>([

  {
    route: "lab-user-menu",
    name: "Lab Listing",
    type: "link",
    icon: "domain"
  },
  {
    route: "reports",
    name: "Reports",
    type: "link",
    icon: "density small"
  },
  {
    route: "ptUpload",
    name: "PT Upload",
    type: "link",
    icon: "ios share",
    roles: ['Admin','Assessor']
  },  
  {
    route: "manageUsers",
    name: "Manage Users",
    type: "link",
    icon: "settings accessibility",
    roles:['Admin']
  },  
  // {
  //   route: "manageLabs",
  //   name: "Manage Labs",
  //   type: "link",
  //   icon: "domain",
  //   roles:['Admin']
  // }, 
  {
    route: "settings",
    name: "Settings",
    type: "link",
    icon: "settings",
    roles:['Admin']
  },  
  {
    route: "help",
    name: "Help",
    type: "link",
    icon: "help",
    roles: ['Admin','Assessor','Office Admin', 'QA', 'User']
  },  
]);